<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Fee Installment</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link slot="right" :to="{ name: 'FeePlanList' }" class="button is-small is-link">Back to list</router-link>
          </div>
        </div>
      </div>
    </section>
    <card-component>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">{{ feeInstallmentList.length > 0 ? 'List of installments' : 'Create new installment' }}</p>
          </div>
        </div>
      </div>
      <template class="is-centered">
        <div class="buttons">
          <b-field grouped group-multiline>
            <b-taglist>
              <b-tag type="is-dark" size="is-medium">Fee Type Name :</b-tag>

              <b-tag type="is-info" size="is-medium">{{ name }}</b-tag>

              <b-tag type="is-dark" size="is-medium">Amount :</b-tag>

              <b-tag type="is-info" size="is-medium">{{ amount }}</b-tag>
              <b-tag type="is-dark" size="is-medium">Financial Year :</b-tag>

              <b-tag type="is-info" size="is-medium">{{ year }}</b-tag>
            </b-taglist>
          </b-field>
        </div>
      </template>

      <b-table :striped="true" v-if="feeInstallmentList.length > 0" id="myDiv" :hoverable="true" :data="feeInstallmentList" :selected.sync="selected">
        <template slot-scope="props">
          <b-table-column label="Name " centered>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column label="Amount " centered>
            <span class="mdi mdi-currency-inr"></span>
            {{ props.row.amount }}
          </b-table-column>

          <b-table-column label="Start Date " centered>
            <b-input
              type="date"
              indicators="dots"
              :disabled="props.row.isDisabled"
              :append-to-body="appendToBody"
              v-model="props.row.startDate"
              placeholder="Start Period..."
              icon="calendar-today"
              editable
            >
            </b-input>
          </b-table-column>
          <!--
             <b-table-column label="Start Date " centered v-if="!editDateFlag">
            {{ new Date(props.row.startDate).toLocaleDateString() }}

          </b-table-column> -->

          <b-table-column label="End Date" centered>
            <b-input type="date" :disabled="props.row.isDisabled" :append-to-body="appendToBody" v-model="props.row.endDate" placeholder="End date..." icon="calendar-today"> </b-input>
          </b-table-column>

          <b-table-column label="Due Date" centered>
            <b-input type="date" :disabled="props.row.isDisabled" :append-to-body="appendToBody" v-model="props.row.dueDate" placeholder="Due Period..." icon="calendar-today"> </b-input>
          </b-table-column>
          <b-table-column label="Action">
            <button class="button" @click="getVisible(props.row, props.index)" v-if="props.row.isDisabled && isSuperAdmin">Adjust Date</button>
            <a @click="updateDate(props.row.id, props.row.feeComponentID, props.row.startDate, props.row.endDate, props.row.dueDate)" v-if="!props.row.isDisabled && isSuperAdmin"> Save Date</a>
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-danger has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No Record !! Check below to create New Fee Installment</p>
            </div>
          </section>
        </template>
      </b-table>
    </card-component>

    <card-component v-if="!feeInstallmentList.length > 0">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">New Fee Installment</p>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label">Installment Type <span class="has-text-danger">*</span></label>
          <div class="control">
            <span class="select is-fullwidth">
              <select name="academicYear" v-model="InstallmentID" required @change="getNoInstallment()">
                <option value="">---Select ---</option>
                <option :value="t.id" v-for="t in type" :key="t.id"> {{ t.name }}</option>
              </select>
            </span>
          </div>
        </div>
      </div>
      <div v-if="visible || feeInstallmentList.length > 0">
        <form @submit.prevent="saveFeeStructure()">
          <b-table :striped="true" :hoverable="true" :data="feeInstallmentInput">
            <template slot-scope="props">
              <b-table-column label="Serial No " :value="(props.row.position = `${props.index + 1}`)" centered>
                {{ props.index + 1 }}
              </b-table-column>
              <b-table-column label="Name" centered>
                <input class="input custom-input has-text-right" style="border:none" readonly :value="(props.row.name = `Installment  ${props.index + 1}`)" type="text" />
              </b-table-column>

              <b-table-column class="backrgound" label="Start Due Period" centered>
                <b-datepicker
                  required
                  indicators="dots"
                  :min-date="min"
                  :max-date="max"
                  :append-to-body="appendToBody"
                  v-model="props.row.startDate"
                  placeholder="Start Period..."
                  icon="calendar-today"
                  editable
                >
                </b-datepicker>
              </b-table-column>

              <b-table-column label="End Due Period" centered>
                <b-datepicker
                  required
                  :min-date="props.row.startDate"
                  :max-date="max"
                  :append-to-body="appendToBody"
                  v-model="props.row.endDate"
                  placeholder="End date..."
                  icon="calendar-today"
                  editable
                >
                </b-datepicker>
              </b-table-column>

              <b-table-column label="Due Date" centered>
                <b-datepicker required :min-date="min" :max-date="max" :append-to-body="appendToBody" v-model="props.row.dueDate" placeholder="Due Period..." icon="calendar-today" editable>
                </b-datepicker>
              </b-table-column>

              <b-table-column label="Amount" centered>
                <input class="input custom-input has-text-right" size="is-medium" min="0" step="any" required v-model="props.row.amount" @input="calculateTotalOnEvent" type="number" />
              </b-table-column>

              <!-- <b-table-column label="Description" centered>
                <input class="input custom-input has-text-right" v-model="props.row.description" type="text" />
              </b-table-column> -->
              <template>
                <b-table-column label="Action" width="140" centered>
                  <div class="buttons">
                    <button class="button is-small is-danger" type="button" title="Delete" v-if="feeInstallmentInput.length > 0" @click="deleteFeeBreakout(props.index)">
                      <b-icon icon="delete" size="is-small"></b-icon>
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button class="button is-small is-primary" type="button" title="Add new" v-if="feeInstallmentInput.length == props.index + 1" @click="addFeeBreakout(props.row)">
                      <b-icon icon="plus" size="is-small"></b-icon>
                    </button>
                  </div>
                </b-table-column>
              </template>
            </template>
            <template slot="footer">
              <th>
                <div>
                  <div></div>
                </div>
              </th>
              <th>
                <div>
                  <div></div>
                </div>
              </th>
              <th>
                <div>
                  <div></div>
                </div>
              </th>
              <th>
                <div>
                  <div></div>
                </div>
              </th>

              <th>
                <div>
                  <div>Total Amount</div>
                </div>
              </th>
              <th>
                <div>
                  <div>
                    <span class="mdi mdi-currency-inr"></span>
                    <b-tooltip :label="amount ? `Must be ${amount}` : ''" position="is-bottom" type="is-info is-light" always>
                      {{ totalAmount }}
                    </b-tooltip>
                  </div>
                </div>
              </th>
              <th>
                <div></div>
              </th>
            </template>
          </b-table>

          <footer class="column has-text-right">
            <button class="button is-success" type="submit">Add</button>
          </footer>
        </form>
      </div>
    </card-component>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import stores from '@/stores'

import _ from 'lodash'

export default {
  name: 'AddFeeInstallment',
  components: {
    CardComponent
  },
  props: ['componentID', 'breakDownID'],
  data () {
    return {
      columns: [{ label: 'Particulars' }, { label: 'Amount' }],
      NoOfInstallment: '',
      InstallmentID: '',
      visible: true,
      feeInstallmentInput: [],
      feeInstallmentList: [],
      type: [],
      year: '',
      tempData: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      listAmount: '',
      appendToBody: true,
      installmentType: '',
      totalAmount: 0,
      initialYear: null,
      min: '',
      max: '',
      temp: {},
      selected: {},
      name: '',
      amount: ''
    }
  },
  watch: {
    selected: function (values) {
      console.log('values--', values)
    }
  },
  created: async function () {
    await this.getInstallmentData()
    await this.getinstallmentType()
  },
  computed: {
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  methods: {
    getVisible (data, index) {
      data.isDisabled = !data.isDisabled
      console.log(data.isDisabled, this.feeInstallmentList[index].isDisabled)
    },

    updateDate: async function (id, componenetID, start, end, due) {
      try {
        let formData = {
          startDate: start,
          endDate: end,
          dueDate: due,
          feeComponentID: componenetID
        }

        this.loadingComponent = this.$buefy.loading.open()
        await http.put(`${constants.API_URL}/api/fee-installment/${id}`, formData)
        this.loadingComponent.close()
        await this.getInstallmentData()

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    calculateTotalOnEvent: function () {
      this.totalAmount = _.sumBy(this.feeInstallmentInput, item => {
        return item && item.amount ? Number(item.amount) : 0
      })
      return this.totalAmount.toFixed(2)
    },
    getInstallmentData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/fee-installment-By-FeePlan?feeComponentID=${this.componentID}&feeComponentFeeTypeMapID=${this.breakDownID}`)
        this.tempData = response.data
        this.year = this.tempData.feeComponent.franchiseeAcademicYear.academicYear
        this.amount = this.tempData.amount
        this.name = this.tempData.feeType.name

        const years = this.year.split('-')
        this.initialYear = years[0]
        const startdt = new Date(years[0] + '-04-01')
        const endt = new Date(years[1] + '-03-31')
        this.min = new Date(startdt.getFullYear(), startdt.getMonth(), startdt.getDate())
        this.max = new Date(endt.getFullYear(), endt.getMonth(), endt.getDate())

        if (this.InstallmentID === '') {
          this.visible = false
        } else {
          this.visible = true
        }
        this.tempData.feeInstallments.forEach(Obj => {
          Obj.startDate = moment(Obj.startDate).format('YYYY-MM-DD')
          Obj.endDate = moment(Obj.endDate).format('YYYY-MM-DD')
          Obj.dueDate = moment(Obj.dueDate).format('YYYY-MM-DD')
          Obj.isDisabled = true
        })
        this.feeInstallmentList = this.tempData.feeInstallments
        this.footerAmount()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getNoInstallment: function (newDate) {
      let temp = []
      if (this.InstallmentID === '') {
        this.visible = false
      } else {
        this.visible = true
      }
      const InstallmentObj = this.type.find(Obj => Obj.id === this.InstallmentID)
      if (InstallmentObj) {
        this.NoOfInstallment = Number(InstallmentObj.noOfInstallment)
        this.feeInstallmentInput = []
        this.installmentType = InstallmentObj.name.toLowerCase()
        switch (this.installmentType) {
          case 'yearly':
            this.feeInstallmentInput.push({
              name: '',
              startDate: newDate || moment(`04/01/${Number(this.initialYear)}`),

              endDate: newDate || moment(`03/31/${Number(this.initialYear) + 1}`),
              dueDate: newDate || moment(`03/31/${Number(this.initialYear) + 1}`),
              amount: this.amount
            })

            break

          case 'monthly':
            let startDate = newDate || moment(`04/01/${Number(this.initialYear)}`)

            let endDate = newDate || moment(`04/30/${Number(this.initialYear)}`)

            let dueDate = newDate || moment(`04/30/${Number(this.initialYear)}`)

            // let startDate = newDate ? moment(newDate).startOf('month') : moment().startOf('month')

            // let endDate = newDate ? moment(newDate).endOf('month') : moment().endOf('month')

            // let dueDate = newDate ? moment(newDate).endOf('month') : moment().endOf('month')
            for (let i = 1; i <= 12; i++) {
              let feeObj = {
                name: '',
                amount: (this.amount / 12).toFixed(2),

                startDate: startDate,
                endDate: endDate,
                dueDate: dueDate
              }
              if (i > 1) {
                startDate = moment(startDate)
                  .add(1, 'months')
                  .startOf('month')

                endDate = moment(endDate)
                  .add(1, 'months')
                  .endOf('month')

                dueDate = moment(dueDate)
                  .add(1, 'months')
                  .endOf('month')

                // startDate = moment(endDate).add(1, 'day')
                // endDate = moment(startDate).add(1, 'months')
                // dueDate = moment(startDate).add(1, 'months')
                feeObj.startDate = startDate
                feeObj.endDate = endDate
                feeObj.dueDate = dueDate
              }

              temp.push(feeObj)
              let finalPosCalculation = ''
              if (i === 11) {
                finalPosCalculation = _.sumBy(temp, item => {
                  return Number(item.amount)
                })

                let result11thPos = Math.abs(this.amount - finalPosCalculation)

                feeObj.amount = result11thPos.toFixed(2)
              }
              this.feeInstallmentInput.push(feeObj)
            }

            break

          case 'quarterly':
            startDate = newDate || moment(`04/01/${Number(this.initialYear)}`)

            endDate = newDate || moment(`06/30/${Number(this.initialYear)}`)

            dueDate = newDate || moment(`06/30/${Number(this.initialYear)}`)

            // startDate = newDate || moment()
            // endDate = newDate ? moment(newDate).add(3, 'months') : moment().add(3, 'months')
            // dueDate = newDate ? moment(newDate).add(2, 'months') : moment().add(2, 'months')
            for (let i = 1; i <= this.NoOfInstallment; i++) {
              let feeObj = {
                name: '',
                amount: (this.amount / 4).toFixed(2),

                startDate: startDate,
                endDate: endDate,
                dueDate: dueDate
              }
              if (i > 1) {
                startDate = moment(startDate)
                  .add(3, 'months')
                  .startOf('month')
                endDate = moment(endDate)
                  .add(3, 'months')
                  .endOf('month')
                dueDate = moment(dueDate)
                  .add(3, 'months')
                  .endOf('month')
                feeObj.startDate = startDate
                feeObj.endDate = endDate
                feeObj.dueDate = dueDate
              }
              temp.push(feeObj)
              let finalPosCalculation = ''
              if (i === 3) {
                finalPosCalculation = _.sumBy(temp, item => {
                  return Number(item.amount)
                })

                let result11thPos = Math.abs(this.amount - finalPosCalculation)

                feeObj.amount = result11thPos.toFixed(2)
              }
              this.feeInstallmentInput.push(feeObj)
            }
            break
          case 'custom':
            this.feeInstallmentInput.push({
              name: '',
              startDate: moment(),
              endDate: moment(),
              dueDate: moment(),
              amount: ''
            })
            break
          default:
        }

        this.feeInstallmentInput.forEach(fee => {
          fee.startDate = new Date(fee.startDate)
          fee.endDate = new Date(fee.endDate)
          fee.dueDate = new Date(fee.dueDate)
        })
      }

      this.footerAmount()
    },
    getinstallmentType: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/fee-installment-type`)
        this.type = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    saveFeeStructure: async function () {
      try {
        const feePlanObj = {
          feeComponentFeeTypeMapID: this.breakDownID,
          feeInstallment: this.feeInstallmentInput,
          feeComponentID: this.componentID
        }
        this.loadingComponent = this.$buefy.loading.open()
        await http.post(`${constants.API_URL}/api/fee-installment`, feePlanObj)
        this.loadingComponent.close()
        await this.getInstallmentData()

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    addFeeBreakout: function (row) {
      this.feeInstallmentInput.push({
        name: '',
        startDate: null,
        endDate: null,
        dueDate: null,
        amount: ''
      })
    },
    deleteFeeBreakout: function (row) {
      delete this.feeInstallmentInput[row]
      this.feeInstallmentInput.splice(row, 1)

      this.calculateTotalOnEvent()
    },
    getClass: function (isActive) {
      return !isActive ? 'tag is-danger' : 'tag is-success'
    },
    footerAmount () {
      if (Number(this.InstallmentID === 4)) {
        return (this.totalAmount = 0)
      } else {
        return (this.totalAmount = this.amount)
      }
    },
    changeDate: function (newDate) {
      this.getNoInstallment(moment(newDate))
    }
  }
}
</script>

<style scoped>
::placeholder {
  color: black;
  font-size: 1rem;
}
</style>
